(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UserGroupItemViewModel', UserGroupItemViewModelFactory);

  /** @ngInject */
  function UserGroupItemViewModelFactory() {
    function UserGroupItemViewModel(groupJson) {
      this.id = groupJson.id;
      this.name = groupJson.name;
      //this.userCount = groupJson.users.length;

      init.call(this);
    }

    UserGroupItemViewModel.prototype.destroy = function () {
    };

    return UserGroupItemViewModel;

    function init() {
      refresh.call(this);
    }

    function refresh() {
    }
  }
})();
